"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsType = void 0;
var EventsType;
(function (EventsType) {
    EventsType[EventsType["UserJoinedTeam"] = 0] = "UserJoinedTeam";
})(EventsType = exports.EventsType || (exports.EventsType = {}));
